export const sortTypes = {
  TERMINAL: {
    key: 'terminal',
    sorter: (a, b) => {
      return a.terminal_id === null ? 1 : b.terminal_id === null ? -1 : a.terminal.toString().localeCompare(b.terminal)
    },
  },
  SUPPLIER: {
    key: 'supplier',
    sorter: (a, b) => {
      return a.supplier_id === null ? 1 : b.supplier_id === null ? -1 : a.supplier.toString().localeCompare(b.supplier)
    },
  },
  PRODUCT: {
    key: 'product',
    sorter: (a, b) => {
      return a.product_id === null ? 1 : b.product_id === null ? -1 : a.product.toString().localeCompare(b.product)
    },
  },
  LOADED: {
    key: 'loaded',
    sorter: (a, b) => (a.loaded > b.loaded ? -1 : 1),
  },
  SCHEDULED: {
    key: 'scheduled',
    sorter: (a, b) => (a.scheduled > b.scheduled ? -1 : 1),
  },
  PLANNED: {
    key: 'planned',
    sorter: (a, b) => (a.planned > b.planned ? -1 : 1),
  },
  MIN: {
    key: 'min',
    sorter: (a, b) => (a.directive_min > b.directive_min ? -1 : 1),
  },
  MAX: {
    key: 'max',
    sorter: (a, b) => (a.directive_max > b.directive_max ? -1 : 1),
  },
  TOTAL: {
    key: 'total',
    sorter: (a, b) => (Math.abs(a.delta_to_directive) > Math.abs(b.delta_to_directive) ? -1 : 1),
  },
  DAILYALLOCATION: {
    key: 'dailyAllocation',
    sorter: (a, b) => (a.daily_allocation > b.daily_allocation ? -1 : 1),
  },
  WEEKLYALLOCATION: {
    key: 'weeklyAllocation',
    sorter: (a, b) => (a.weekly_allocation > b.weekly_allocation ? -1 : 1),
  },
  MONTHLYALLOCATION: {
    key: 'monthlyAllocation',
    sorter: (a, b) => (a.monthly_allocation > b.monthly_allocation ? -1 : 1),
  },
  DAILYPERCENT: {
    key: 'dailyPercent',
    sorter: (a, b) => (a.daily_percent > b.daily_percent ? -1 : 1),
  },
  WEEKLYPERCENT: {
    key: 'weeklyPercent',
    sorter: (a, b) => (a.weekly_percent > b.weekly_percent ? -1 : 1),
  },
  MONTHLYPERCENT: {
    key: 'monthlyPercent',
    sorter: (a, b) => (a.monthly_percent > b.monthly_percent ? -1 : 1),
  },
  DAILYSTART: {
    key: 'dailyStart',
    sorter: (a, b) => (a.daily_start_allocation > b.daily_start_allocation ? -1 : 1),
  },
  WEEKLYSTART: {
    key: 'weeklyStart',
    sorter: (a, b) => (a.weekly_start_allocation > b.weekly_start_allocation ? -1 : 1),
  },
  MONTHLYSTART: {
    key: 'monthlyStart',
    sorter: (a, b) => (a.monthly_allocation_start > b.monthly_start_allocation ? -1 : 1),
  },
  WEEKLYPACE: {
    key: 'weeklyPace',
    sorter: (a, b) => (a.weekly_allocation_pace > b.weekly_allocation_pace ? -1 : 1),
  },
  MONTHLYPACE: {
    key: 'monthlyPace',
    sorter: (a, b) => (a.allocation_pace > b.allocation_pace ? -1 : 1),
  },
  CONTRACTPACE: {
    key: 'contractPace',
    sorter: (a, b) => (a.contract_pace > b.contract_pace ? -1 : 1),
  },
}
